import { render, staticRenderFns } from "./VatSettings.vue?vue&type=template&id=6cc1880a&scoped=true&"
import script from "./VatSettings.vue?vue&type=script&lang=js&"
export * from "./VatSettings.vue?vue&type=script&lang=js&"
import style0 from "./VatSettings.vue?vue&type=style&index=0&id=6cc1880a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1880a",
  null
  
)

export default component.exports